/* Reconstruct a field's instruction timeline from the draft's round-level
   refinement_history. Per-field history is only persisted at save time
   (ExtractorField.instruction_history), so during a live draft session we derive
   it client-side from each round's instruction_snapshots. */
export function buildFieldHistory(field, refinementHistory, origin) {
  const initialSource = origin === "reopened" ? "saved" : origin === "manual" ? "manual" : "ai_generated";
  const rounds = (refinementHistory || []).filter(
    (r) => (r.fields_updated || []).includes(field.field_key) && r.instruction_snapshots?.[field.field_key]
  );
  if (!rounds.length) {
    return [{
      v: 1,
      source: initialSource,
      instruction: field.instruction,
      note: origin === "reopened" ? "Current saved version" : "Current version",
    }];
  }
  const entries = [{
    v: 1,
    source: initialSource,
    instruction: rounds[0].instruction_snapshots[field.field_key].before,
    note: "Initial version",
  }];
  rounds.forEach((r, i) => entries.push({
    v: i + 2,
    source: "refined",
    instruction: r.instruction_snapshots[field.field_key].after,
    note: r.feedback ? `Refined — "${r.feedback}"` : "Refined",
  }));
  return entries;
}
